import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/utils";

type EventRow = {
  id: string;
  type: string;
  issuanceId: string;
  emittedAt: string;
  deliveredToCrmAt: string | null;
  failedAt: string | null;
};

export function EventsPage() {
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ["events"],
    queryFn: () => api.get<{ items: EventRow[] }>("/api/admin/events"),
    refetchInterval: 10_000,
  });
  const replay = useMutation({
    mutationFn: (id: string) => api.post(`/api/admin/events/${id}/replay`, {}),
    onSuccess: () => { toast.success("Replayed"); qc.invalidateQueries({ queryKey: ["events"] }); },
  });
  return (
    <div className="space-y-4 max-w-6xl">
      <h1 className="font-head text-2xl font-semibold">Events</h1>
      <p className="text-sm text-muted-foreground">
        Canonical event log. This is what the future ElevateCRM adapter consumes.
      </p>
      <Card>
        <table className="w-full text-sm">
          <thead><tr className="border-b border-admin-rule text-left"><th className="p-3">Type</th><th className="p-3">Emitted</th><th className="p-3">CRM</th><th className="p-3 text-right">Actions</th></tr></thead>
          <tbody>
            {data?.items.map((e) => (
              <tr key={e.id} className="border-b border-admin-rule">
                <td className="p-3"><Badge variant="outline">{e.type}</Badge></td>
                <td className="p-3 text-xs">{formatDateTime(e.emittedAt)}</td>
                <td className="p-3">
                  {e.failedAt ? <Badge variant="danger">failed</Badge>
                    : e.deliveredToCrmAt ? <Badge variant="ok">delivered</Badge>
                    : <Badge variant="muted">pending</Badge>}
                </td>
                <td className="p-3 text-right">
                  <Button size="sm" variant="ghost" onClick={() => replay.mutate(e.id)}>Replay</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
